import React, { useContext } from 'react';
import UserName from '@molecules/UserName';
import AbookChipItem from '@molecules/formbuilder/controls/Abook/AbookChipItem/AbookChipItem';
import { parseDisplayFormatCell } from '@utils/documentUtils';
import { buildAbookCellPairs } from '@utils/tableHelper';
import { ITableColumnAbook } from '@models/Forms/IForms';
import { DocumentRuntimeContext } from '@/context/DocumentRuntimeContext';

/**
 * Рендер ячейки abook-колонки таблицы в просмотре: ФИО пользователей с hover-карточкой контактов
 * (UserHoverCard через UserName/AbookChipItem). Если сопоставить имена с ключами нельзя
 * (eval / table-source / мультиполя+литералы / рассинхрон количества) — рендерит как раньше,
 * текстом через parseDisplayFormatCell, без hover (нулевой регресс).
 */
const AbookCellView: React.FC<{ column: ITableColumnAbook; p: any }> = ({ column, p }) => {
    const runtime = useContext(DocumentRuntimeContext);
    if (runtime.mode === 'supportPreview') {
        return <div>{parseDisplayFormatCell(column.displayFormat, p.data, column.evalDisplayFormat)}</div>;
    }

    const pairs = buildAbookCellPairs(column, p);

    if (!pairs) {
        return <div>{parseDisplayFormatCell(column.displayFormat, p.data, column.evalDisplayFormat)}</div>;
    }

    if (column.chipsView) {
        return (
            <div className="abook-chips-items">
                {pairs.map((pair, i) => (
                    <AbookChipItem key={i} item={pair.name} userKey={pair.key} showRemoveIcon={false} />
                ))}
            </div>
        );
    }

    return (
        <div>
            {pairs.map((pair, i) => (
                <React.Fragment key={i}>
                    {i > 0 ? ', ' : null}
                    <UserName userKey={pair.key} name={pair.name} avatar />
                </React.Fragment>
            ))}
        </div>
    );
};

export default AbookCellView;
